import { TmTableError } from '@/core/error/table/tmTableError'

export class TmTableFilterError extends TmTableError {
  public name = 'TmTableFilterError'
}
